module.exports = __webpack_public_path__ + "img/dd_grey_border.3bb50a2b.svg";